$(document).ready(function() {
    $('#city_select').niceSelect();
    $('#region_select').niceSelect();
});

// ==========================================
// 1. ЗАВАНТАЖЕННЯ ДАНИХ З SHOPIFY STOREFRONT API
// ==========================================
(function() {
    console.log('Ініціалізація завантаження таблиці магазинів (з урахуванням мови)...');

    let currentLang = document.documentElement.lang.toUpperCase(); 
    if (currentLang.includes('-')) {
        currentLang = currentLang.split('-')[0]; 
    }

    const STOREFRONT_TOKEN = 'b90bbbba1f399e6e629be11f81a00e9c';
    const GRAPHQL_ENDPOINT = '/api/2026-04/graphql.json'; 
    const CACHE_KEY = `stores_data_cache_v2_${currentLang}`; 

    async function fetchStoresData() {
        const cachedData = sessionStorage.getItem(CACHE_KEY);
        if (cachedData) {
            try { return JSON.parse(cachedData); } 
            catch (e) { console.error('Помилка читання кешу магазинів', e); }
        }

        const allStores = [];
        let hasNextPage = true;
        let cursor = null;

        while (hasNextPage) {
            const query = `
            query getStores($cursor: String, $lang: LanguageCode) @inContext(language: $lang) {
                metaobjects(type: "authorized_retail_stores", first: 250, after: $cursor) {
                    pageInfo { hasNextPage endCursor }
                    nodes {
                        name_store: field(key: "name_store") { value }
                        region_store: field(key: "region_store") { value }
                        adress_store: field(key: "adress_store") { value }
                        phone: field(key: "phone") { value }
                        latitude_on_map: field(key: "latitude_on_map") { value }
                        longitude_on_map: field(key: "longitude_on_map") { value }
                        site_store: field(key: "site_store") { value }
                    }
                }
            }
            `;

            try {
                const response = await fetch(GRAPHQL_ENDPOINT, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
                    },
                    body: JSON.stringify({ query, variables: { cursor, lang: currentLang } })
                });

                if (!response.ok) throw new Error(`Помилка HTTP: ${response.status}`);
                
                const { data, errors } = await response.json();
                if (errors) {
                    console.error('Помилка GraphQL:', errors);
                    break;
                }

                data.metaobjects.nodes.forEach(node => {
                    allStores.push({
                        name_store: node.name_store?.value || '',
                        region_store: node.region_store?.value || '',
                        adress_store: node.adress_store?.value || '',
                        phone: node.phone?.value || '',
                        latitude_on_map: node.latitude_on_map?.value || '',
                        longitude_on_map: node.longitude_on_map?.value || '',
                        site_store: node.site_store?.value || ''
                    });
                });

                hasNextPage = data.metaobjects.pageInfo.hasNextPage;
                cursor = data.metaobjects.pageInfo.endCursor;
            } catch (error) {
                console.error('Не вдалося завантажити магазини:', error);
                break;
            }
        }

        if (allStores.length > 0) {
            sessionStorage.setItem(CACHE_KEY, JSON.stringify(allStores));
        }

        return allStores;
    }

    const storesPromise = fetchStoresData();

    document.addEventListener('DOMContentLoaded', async () => {
        const tbody = document.getElementById('stores-table-body');
        
        // Очищаємо HTML від Shopify (Liquid), щоб уникнути блимання невідсортованих даних
        if (tbody) {
            tbody.innerHTML = '<tr><td colspan="8" style="text-align:center; padding: 20px;">Завантаження магазинів...</td></tr>';
        }

        const stores = await storesPromise;
        
        if (!tbody || stores.length === 0) {
            if (tbody) tbody.innerHTML = ''; 
            return;
        }

        stores.sort((a, b) => {
            // Залишаємо a.name_store, оскільки значення вже розпарсено у рядок вище
            const nameA = (a.name_store || "").trim();
            const nameB = (b.name_store || "").trim();

            const getPriority = (str) => {
                const match = str.match(/[a-zA-Zа-яА-ЯіїєґІЇЄҐ0-9]/);
                if (!match) return 4;
                
                const char = match[0].toLowerCase();
                if (/[0-9]/.test(char)) return 1;
                if (/[a-z]/.test(char)) return 2;
                if (/[а-яіїєґ]/.test(char)) return 3;
                return 4;
            };

            const priorityA = getPriority(nameA);
            const priorityB = getPriority(nameB);

            if (priorityA !== priorityB) {
                return priorityA - priorityB; 
            }

            const cleanNameA = nameA.replace(/^[^a-zA-Zа-яА-ЯіїєґІЇЄҐ0-9]+/, '');
            const cleanNameB = nameB.replace(/^[^a-zA-Zа-яА-ЯіїєґІЇЄҐ0-9]+/, '');

            return cleanNameA.localeCompare(cleanNameB, 'uk', { 
                numeric: true, 
                sensitivity: 'base' 
            });
        });
        // =========================================================

        const textWatch = tbody.getAttribute('data-look-title') || 'Дивитися';
        let htmlContent = '';
        
        stores.forEach(store => {
            const hasCoords = store.latitude_on_map && store.longitude_on_map;
            const mapButtonHtml = hasCoords 
                ? `<a class="btn button geolocation-marker-zoom" href="#" data-once="geolocation-marker-zoom-by-anchor">${textWatch}</a>` 
                : '';
                
            const linkButtonHtml = store.site_store 
                ? `<a href="${store.site_store}" rel="nofollow" class="button btn btn--underline" target="_blank">Сайт</a>` 
                : '';

            htmlContent += `
                <tr class="table__row odd">
                    <td headers="view-title-table-column" class="views-field views-field-title table__cell" style="width: 112.949px;">
                        ${store.name_store}
                    </td>
                    <td style="width: 118.301px;">
                        ${store.region_store}
                    </td>
                    <td headers="view-field-adresa-table-column" class="views-field views-field-field-adresa table__cell" style="width: 143.789px;">
                        <p>${store.adress_store}</p>
                    </td>
                    <td headers="view-field-telefon-table-column" class="views-field views-field-field-telefon table__cell" style="width: 64.9414px;">
                        <p>${store.phone}</p>
                    </td>
                    <td headers="view-nid-table-column" class="views-field views-field-nid table__cell" style="width: 60.7812px;">
                        ${mapButtonHtml}
                    </td>
                    <td headers="view-field-posylannya-na-mahazyn-table-column" class="views-field views-field-field-posylannya-na-mahazyn table__cell" style="width: 75.8398px;">
                        ${linkButtonHtml}
                    </td>
                    <td style="width: 131.348px; display: none;">
                        ${store.longitude_on_map}
                    </td>
                    <td style="width: 131.348px; display: none;">
                        ${store.latitude_on_map}
                    </td>
                </tr>
            `;
        });

        tbody.innerHTML = htmlContent;

        // Важливо: сповіщаємо карту, що HTML таблиці повністю згенеровано
        window.dispatchEvent(new CustomEvent('storesLoaded'));
    });

})();

// ==========================================
// 2. ІНІЦІАЛІЗАЦІЯ КАРТИ ТА ПАГІНАЦІЇ
// ==========================================
function initMap() {
    var where_map_elem = document.getElementById('where-map');
    if(!where_map_elem) return; // Запобіжник, якщо карти немає на сторінці
    
    var map_marker = '//axent-store.myshopify.com/cdn/shop/t/2/assets/map-marker.svg?v=30270251411000439041750857284';
    var coordinates = new google.maps.LatLng(49.373812, 29.636763);
    var styledMapType = new google.maps.StyledMapType(
        [{
            "featureType": "administrative.country",
            "elementType": "geometry",
            "stylers": [{ "visibility": "simplified" }, { "hue": "#ff0000" }]
        }], { name: 'Styled Map' }
    );
  
    var map = new google.maps.Map(where_map_elem, {
        center: coordinates,
        zoom: 6,
        mapTypeControlOptions: {
            mapTypeIds: ['roadmap', 'satellite', 'hybrid', 'terrain', 'styled_map']
        },
        mapCluster: {
            styles: [{
                width: 30, height: 30, className: 'marker-clusterer-orange'
            }, {
                width: 40, height: 40, className: 'marker-clusterer-orange'
            }, {
                width: 50, height: 50, className: 'marker-clusterer-orange'
            }]
        },
    });
    
    var markers = [],
        marker,
        infowindow = new google.maps.InfoWindow();

    addTrBackground = function() {
        let table = $('table.table');
        let shownTr = table.find('tbody tr:not([style*="display: none;"])');
        shownTr.each(function(step, el) {
            let curStep = step + 1;
            let odd = true;
            if((curStep % 2) == 0) odd = false;
            if(odd) $(this).addClass('odd');
            else $(this).removeClass('odd');
        });
    };
  
    function addMarkers(markets) {
        markets.each(function(market) {
            let name = $(this).find('td:nth-child(1)').text().trim();
            let region = $(this).find('td:nth-child(2)').text()?.trim();
            let cityRaw = $(this).find('td:nth-child(3)').text().split(',')[0].split('.');
            let city = (cityRaw.length == 1) ? cityRaw[0].trim() : cityRaw[1]?.trim();
            let phone = $(this).find('td:nth-child(4)').text().trim();
            let lng = parseFloat($(this).find('td:nth-child(7)').text());
            let lat = parseFloat($(this).find('td:nth-child(8)').text());
            let addressAr = $(this).find('td:nth-child(3)').text().split(',');
            let address = '';
            
            for(let i = 0; i < addressAr.length; i++) {
                if(i != 0) {
                    address = address + addressAr[i];
                    if(i != addressAr.length - 1) address = address + ', ';
                }
            }

            if(!name || !region || !city || !lat || !lng || isNaN(lat) || isNaN(lng)) return;
        
            marker = new google.maps.Marker({
                position: { lat: lat, lng: lng },
                category: { region: region, city: city },
                map: map,
                icon: map_marker
            });
            
            google.maps.event.addListener(marker, 'click', (function(marker) {
                return function() {
                    let returnedContent = '';
                    if(name) returnedContent = returnedContent + `<strong>${name}</strong>`;
                    if(phone) returnedContent = returnedContent + `<br />${phone}`;
                    if(city || address) returnedContent = returnedContent + `<br />`;
                    if(city) returnedContent = returnedContent + city;
                    if(address) {
                        if(city) returnedContent = returnedContent + ', ';
                        returnedContent = returnedContent + address;
                    }
                    infowindow.setContent(returnedContent);
                    infowindow.open(map, marker);
                }
            })(marker));
            markers.push(marker);
        });
  
        new MarkerClusterer(map, markers, {
            imagePath: "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m",
        });
        
        map.mapTypes.set('styled_map', styledMapType);
        map.setMapTypeId('styled_map');
    }

    createPagination = function(table) {
        let shownTr = table.find('tbody tr:not([style*="display: none;"])');
        if(shownTr.length > 30) {
            let paginationEl = $('#storelocations .pagin');
            if(paginationEl.length) paginationEl.remove();
            
            paginationEl = '<div class="pagin container"></div>';
            $('#storelocations .table--adress').after(paginationEl);
            paginationEl = $('#storelocations .pagin');

            let additionalPaginPage = 0;
            if((shownTr.length % 30) != 0) additionalPaginPage = 1;
            let paginCount = parseInt(shownTr.length / 30 + additionalPaginPage);
            for(let i = 0; i < paginCount; i++) {
                if(i == 0) paginationEl.append('<div class="page-link active" data-pagin="1">'+(i + 1)+'</div>');
                else if(i < 9) paginationEl.append('<div class="page-link" data-pagin="'+(i + 1)+'">'+(i + 1)+'</div>');
            }
            paginationEl.append('<div class="right" data-pagin="2">➝</div>');
            if(paginCount > 9) paginationEl.append('<div class="end" data-pagin="'+paginCount+'">⇥</div>');
        
            shownTr.each(function(step, el) {
                if(step >= 30) $(this).addClass('pagin-hide');
                else $(this).removeClass('pagin-hide');
            });

            let paginLinks = '.left, .right, .page-link, .start, .end';
            paginationEl.on('click', paginLinks, function() {
                let curPagin = $(this).data('pagin');
                let totalPaginAdded = 0;
                
                paginationEl.find(paginLinks).remove();
                paginationEl.append('<div class="page-link active" data-pagin="'+curPagin+'">'+curPagin+'</div>');
                for(let i = (curPagin - 1); i > 0; i--) {
                    if(totalPaginAdded < 4) {
                        paginationEl.prepend('<div class="page-link" data-pagin="'+i+'">'+i+'</div>');
                        totalPaginAdded++;
                    } else break;
                }
                for(let i = (curPagin + 1); i <= paginCount; i++) {
                    if(totalPaginAdded < 8) {
                        paginationEl.append('<div class="page-link" data-pagin="'+i+'">'+i+'</div>');
                        totalPaginAdded++;
                    } else break;
                }
                if(curPagin > 1) {
                    paginationEl.prepend('<div class="left" data-pagin="1">➝</div>');
                    paginationEl.prepend('<div class="start" data-pagin="1">⇤</div>');
                }
                if(curPagin < paginCount) {
                    paginationEl.append('<div class="right" data-pagin="'+(curPagin + 1)+'">➝</div>');
                    paginationEl.append('<div class="end" data-pagin="'+paginCount+'">⇥</div>');
                }
                if(curPagin == shownTr.length) {
                    paginationEl.find('.right').remove();
                    paginationEl.find('.end').remove();
                }

                shownTr.removeClass('pagin-hide');
                for(let i = 0; i < shownTr.length; i++) {
                    if(i >= (curPagin * 30) || i < (curPagin * 30 - 30)) shownTr.eq(i).addClass('pagin-hide');
                }
                
                let headerHeight = 0;
                let headerEl = $('.shopify-section-main-header header[data-header-sticky]');
                if(headerEl.length) headerHeight = headerEl.height();
                $([document.documentElement, document.body]).animate({
                    scrollTop: (table.offset().top - headerHeight - 5)
                }, 2000);
            });
        } else {
            let paginationEl = $('#storelocations .pagin');
            if(paginationEl.length) paginationEl.remove();
            shownTr.removeClass('pagin-hide');
            shownTr.show();
        }
        if(shownTr.length) table.show();
        else table.hide();
    };

    // --- СИНХРОНІЗАЦІЯ ДАНИХ ТА КАРТИ ---
    const initializeTableData = () => {
        let markets = $('#stores-table-body tr');
        if(markets.length > 0) {
            addMarkers(markets);
            addTrBackground();
            createPagination($('#storelocations .table--adress'));
        }
    };

    // Перевіряємо, чи таблиця вже завантажена GraphQL-скриптом
    if ($('#stores-table-body tr').length > 0) {
        initializeTableData();
    } else {
        // Якщо ні, чекаємо на подію готовності від скрипта вище
        window.addEventListener('storesLoaded', initializeTableData);
    }

    // ==========================================
    // ФІЛЬТРИ ТА ІНШІ ГЛОБАЛЬНІ МЕТОДИ
    // ==========================================
    filterRegion = function(region) {
        region = region.trim();
        let showAll = false;
        if(markers.length) {
            filterTable(region, false);
            var bounds = new google.maps.LatLngBounds();
            var visibleMarkersCount = 0;
            
            if(region.length !== 0) {
                updateSelectValues('#city_select', getCitiesByRegion(region));
                for(let i = 0; i < markers.length; i++) {
                    let marker = markers[i];
                    if(marker.category.region === region || region.length === 0) {
                        marker.setVisible(true);
                        bounds.extend(marker.getPosition());
                        visibleMarkersCount++;
                    } else {
                        marker.setVisible(false);
                    }
                }
            } else {
                showAll = true;
                for(let i = 0; i < markers.length; i++) {
                    let marker = markers[i];
                    if(marker.getPosition()) {
                        marker.setVisible(true);
                        bounds.extend(marker.getPosition());
                        visibleMarkersCount++;
                    }
                }
            }
            
            if(visibleMarkersCount > 0) {
                map.fitBounds(bounds);
            }
            
            if(showAll) {
                updateSelectValues('#region_select', getAllRegions());
                updateSelectValues('#city_select', getAllCities());
            }
        }
    };

    filterCity = function(city) {
        city = city.trim();
        if(markers.length) {
            filterTable(false, city);
            let cityAndRegionEmpty = false;
            var bounds = new google.maps.LatLngBounds();
            var visibleMarkersCount = 0;
            
            if(city.length === 0) {
                let region = $('#region_select').val();
                if(region) {
                    filterRegion(region);
                    return;
                } else {
                    cityAndRegionEmpty = true;
                }
            }
            
            for(let i = 0; i < markers.length; i++) {
                let marker = markers[i];
                if(marker.category.city === city || cityAndRegionEmpty) {
                    marker.setVisible(true);
                    bounds.extend(marker.getPosition());
                    visibleMarkersCount++;
                    
                    if(city.length !== 0) {
                        updateSelectValues('#region_select', getRegionByCity(city));
                        setSelect('region_select', Object.keys(getRegionByCity(city))[0]);
                    }
                } else {
                    marker.setVisible(false);
                }
            }
            
            if(visibleMarkersCount > 0) {
                map.fitBounds(bounds);
            }
        }
    };
  
    filterTable = function(region, city) {
        let table = $('#storelocations .table--adress');
        
        // Завжди показуємо саму таблицю
        table.show(); 

        table.find('tbody tr').each(function() {
            let curRegion = $(this).find('td:nth-child(2)').text().trim();
            let cityRaw = $(this).find('td:nth-child(3)').text().split(',')[0].split('.');
            let curCity = cityRaw[1]?.trim() || cityRaw[0]?.trim();

            if (city?.length) {
                if (curCity == city) $(this).css('display', 'table-row');
                else $(this).hide();
            } else if (region?.length) {
                if (region == curRegion) $(this).css('display', 'table-row');
                else $(this).hide();
            } else {
                // Якщо фільтри скинуті (Показати усе) — показуємо цей рядок
                $(this).css('display', 'table-row');
            }
        });

        // Оновлюємо стилі та пагінацію для відфільтрованого або повного списку
        addTrBackground();
        createPagination(table);
    };
  
    showMarker = function(latLng) {
        if(markers.length) {
            map.setCenter(latLng);
            map.setZoom(15); 
            
            markers.forEach(function(marker) {
                if (marker.getPosition().lat() === latLng.lat && marker.getPosition().lng() === latLng.lng) {
                    google.maps.event.trigger(marker, 'click');
                }
            });
            
            setTimeout(() => {
                document.querySelector('.tabs-body')?.scrollIntoView({
                    block: "start", behavior: "smooth"
                });
            }, 100);
        }
    };

    updateSelectValues = function(element, selectValues) {
        $(element).find('option[value!=""]').remove();
        $.each(selectValues, function(key, value) {
            $(element).append($("<option></option>").attr("value", key).text(value));
        });
        if($.fn.niceSelect) $(element).niceSelect('update');
    };

    getAllCities = function() {
        const cities = {};
        markers.forEach(key => { cities[key.category.city] = key.category.city; });
        return cities;
    };

    getRegionByCity = function(city) {
        const result = markers.filter(r => r.category.city === city)[0]?.category;
        if(!result) return {};
        return { [result.region]: result.region };
    };

    getAllRegions = function() {
        const regions = {};
        markers.forEach(key => { regions[key.category.region] = key.category.region; });
        return regions;
    };

    getCitiesByRegion = function(region) {
        const cities = {};
        markers.filter(r => r.category.region === region).map(i => i.category).forEach(c => cities[c.city] = c.city);
        return cities;
    };

    setSelect = function(select, value) {
        let options = document.getElementById(select).options;
        for(let i=0; i<options.length; i++) {
            if(options[i].value == value) { options[i].selected = true; break; }
        }
        if($.fn.niceSelect) $(`#${select}`).niceSelect('update');
    };
}

// ==========================================
// 3. ДОДАТКОВІ СЛУХАЧІ ПОДІЙ ДЛЯ ІНТЕРФЕЙСУ
// ==========================================
document.addEventListener('DOMContentLoaded', function() {
  
    let viewed = localStorage.getItem('viewedStores') || [];
    if(!Array.isArray(viewed)) viewed = viewed.split(',');

    $('body').on('click', '.geolocation-marker-zoom', function(e) {
        e.preventDefault();
        e.stopPropagation();
        let el = this;

        let storeLocatorId = el.getAttribute('href').replace('#map', '');
        viewed.push(storeLocatorId);
        el.closest('tr').classList.add('viewed');

        const latLng = {
            lat: parseFloat(e.target.closest('tr').querySelector('td:nth-child(8)').innerText),
            lng: parseFloat(e.target.closest('tr').querySelector('td:nth-child(7)').innerText)
        };
        
        if (typeof showMarker === "function") showMarker(latLng);
        localStorage.setItem('viewedStores', viewed.join(','));
    });
  
    if(localStorage.getItem('viewedStores')) {
        let $stores = document.querySelectorAll('#storelocations tr');
        $stores.forEach(store => {
            if(localStorage.getItem('viewedStores').includes(store.dataset.storelocatorid)) {
                store.classList.add('viewed');
            }
        });
    }

    if(typeof replaceHLink === 'function') replaceHLink();
  
    $('#storelocations').delegate('.e-pagination a', 'click', function(e) {
        e.preventDefault();
        $('#storelocations').fadeOut('slow');
        $('#storelocations').fadeIn('slow');
        if(typeof replaceHLink === 'function') replaceHLink();
    });

    document.querySelectorAll('.view-map').forEach(el => {
        el.addEventListener('click', (e) => {
            viewed.push(el.closest('tr').dataset.storelocatorid);
            el.closest('tr').classList.add('viewed');
            const latLng = {
                lat: parseFloat(e.target.dataset.lat),
                lng: parseFloat(e.target.dataset.lng)
            };
            if(typeof showMarker === "function") showMarker(latLng);
            localStorage.setItem('viewedStores', viewed.join(','));
            e.preventDefault();
        });
    });

    $('#region_select, #city_select').on('change', function() {
        var selectedFilter = $(this).find(':selected').text();
        if(selectedFilter !== '') {
            if($(this).attr('id') === 'region_select' && typeof filterRegion === 'function') {
                filterRegion(selectedFilter);
            }
            if($(this).attr('id') === 'city_select' && typeof filterCity === 'function') {
                filterCity(selectedFilter);
            }
        }
    });
  
});